import React from 'react';
import { motion } from 'framer-motion';
export function IdentitySection() {
  return <section id="about" className="py-24 md:py-32 relative overflow-hidden" data-id="element-127">
      <div className="absolute inset-0 z-0" data-id="element-128">
        <img src="https://cdn.magicpatterns.com/uploads/d5nSz1L82oA5h3uMfAYubz/imagen_2.jpg" alt="Luxury Barbershop Interior" className="w-full h-full object-cover opacity-30" data-id="element-129" />
        <div className="absolute inset-0 bg-gradient-to-r from-[#121212] via-[#121212]/80 to-transparent" data-id="element-130"></div>
      </div>

      <div className="container mx-auto px-6 md:px-12 relative z-10" data-id="element-131">
        <motion.div className="max-w-3xl" initial={{
        opacity: 0,
        x: -50
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 1,
        ease: 'easeOut'
      }} data-id="element-132">
          <h2 className="font-serif text-5xl md:text-6xl lg:text-7xl mb-10 leading-tight" data-id="element-133">
            Onyx & Steel <br data-id="element-134" />
            <span className="text-gold italic" data-id="element-135">Identity</span>
          </h2>
          <p className="text-xl md:text-2xl text-white/80 font-light leading-relaxed mb-8" data-id="element-136">
            Onyx represents sophistication. Steel represents strength. Together,
            they define a grooming experience that refuses to compromise.
          </p>
          <p className="text-lg text-white/60 font-light leading-relaxed" data-id="element-137">
            We don't do average. We don't do rushed. We craft confidence, one
            cut at a time.
          </p>
        </motion.div>
      </div>
    </section>;
}